import { connect } from 'react-redux';
import MobileNavigation from '../components/navigation/MobileNavigation';

const mapStateToProps = ({ menu }) => ({ mobileMenuVisible: menu.mobileMenuVisible });

const MobileNavContainer = connect(mapStateToProps)(MobileNavigation);
export default MobileNavContainer;
